<template>
	<div class="payments">
		<div class="moneyBox">
			<div class="topBox">
				<div>
					<p>{{ $t('payments.settleAmount') }}</p>
				</div>
				<div>
					<a>
						<!-- <el-icon :size="14"><Close /></el-icon> -->
						<van-icon name="cross" :size="14" />
					</a>
				</div>
			</div>
			<div class="moneyInfos">
				<!-- <p>Happy Games</p> -->
				<p class="color1">{{ goodName }}</p>
				<p class="price" :class="{'s':String(payMoney).length > 6,'ss':String(payMoney).length > 7}">
					<!-- <el-statistic :value="payMoney" >
						<template #prefix>₩</template>
					</el-statistic> -->
					<span class="el-statistic__content">₩ {{ payMoney }}</span>
				</p>
				<template v-if="commissionMoney > 0">
					<p class="commission mt10">{{ $t('payments.commission') }}：
						<span class="el-statistic__content">₩ {{ commissionMoney }}</span>
					</p>
					<p class="commission">{{ $t('payments.totalMoney') }}：
						<span class="el-statistic__content">₩ {{ payRealMoney }}</span>
					</p>
				</template>
			</div>
			<div class="footBox">
				<p>{{ $t('payments.helpTips1') }}</p>
				<p>{{ $t('payments.helpTips2') }}</p>
			</div>
		</div>
		<div class="typesBox">
			<p class="color1 stitle">{{ $t('payments.allPays') }}</p>
			<div class="typesList">
				<ul>
					<li class="typesItem" :class="{'active': activePays.name == item.name}" v-for="(item,index) in payTypes" :key="index" @click="handlePays(item)">
						<div class="logo">
							<img v-if="item.icon" :src="item.icon" />
						</div>
						<div class="titles">{{ item.name }}<span v-if="item.commission">+{{ item.commission*100 }}% 수수료</span></div>
						<div class="payRadio"></div>
						<i class="sort"><template v-if="item.sort < 10">0</template>{{ item.sort }}</i>
					</li>	
				</ul>
			</div>
			<div class="btnBox">
				<a class="payBtn" @click="handlePayment">
					<!-- <el-statistic :value="payMoney" >
						<template #prefix>{{ $t('payments.paybtn') }} ₩</template>
					</el-statistic> -->
					<span class="el-statistic__content">{{ $t('payments.paybtn') }} ₩ {{ payRealMoney }}</span>
				</a>
				<p>
					<i18n-t keypath="privacy" tag="false">
						<template v-slot:Policy>
							<a place="Policy" href="https://www.gm321321.com/clauseUser" target="_blank">{{ $t('payments.privacyPolicy') }}</a>
						</template>
						<template v-slot:Agreement>
							<a place="Agreement" href="https://www.gm321321.com/clauseService" target="_blank">{{ $t('payments.privacyAgreement') }}</a>
						</template>
					</i18n-t>
				</p>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { getCurrentInstance,onMounted,onBeforeMount,ref,watch,computed, reactive } from 'vue'
	import { payerMaxPay, enjoyPay, ugamePay } from '@/api/pay'
	import { useRoute,useRouter } from 'vue-router'
	const { proxy } = getCurrentInstance();
	const router = useRouter();
	const orders = ref(null)
	const payMoney = ref(0)
	const payRealMoney = ref(0)
	const commissionMoney = ref(0)
	const goodName = ref('')
	const encode = ref('')
	const payTypes = ref([
		{ name: 'NaverPay', type: 'NAVER_PAY', icon: require('@/assets/images/pays/Naver_Pay_KR.png'), sort: 1, company: 'enjoy' },//happy改为enjoy公司(type改了)
		{ name: 'kakaopay', type: 'KAKAO_PAY', icon: require('@/assets/images/pays/Kakao_Pay_KR.png'), sort: 2, company: 'happy' },//enjoy改为happy公司
		{ name: 'Domestic Cards', type: 'CARD', icon: require('@/assets/images/pays/B1_Credit_Card.png'), sort: 3, company: 'happy' },//国内信用卡
		{ name: 'Samsung Pay', type: 'SAMSUNG_PAY', icon: require('@/assets/images/pays/Samsung_Pay_KR.png'), sort: 4, company: 'enjoy' },//enjoy改为happy公司
		{ name: 'Local Credit Card', type: 'CARD', icon: require('@/assets/images/pays/B0_Card.png'), sort: 5, company: 'happy' },//本地信用卡
		{ name: 'Toss', type: 'TOSS', icon: require('@/assets/images/pays/Toss_KR.png'), sort: 6, company: 'UGame' },//
		{ name: 'Virtual Account', type: 'BANK_CARD_KR', icon: require('@/assets/images/pays/Z0_Virtual_Account.png'), sort: 7, company: 'enjoy' },//虚拟账户
		{ name: 'BankTransfer', type: 'BANKTRANSFER', icon: require('@/assets/images/pays/C0_Bank_Transfer.png'), sort: 8, company: 'happy' },//银行转账
		{ name: 'SSG pay', type: 'SSGPAY', icon: require('@/assets/images/pays/SSGPAY_KR.png'), sort: 9, company: 'UGame' },
		{ name: 'PayCo', type: 'PAYCO', icon: require('@/assets/images/pays/PAYCO_KR.png'), sort: 10, company: 'UGame' },
		{ name: 'NetBanking', type: 'NETBANKING', icon: require('@/assets/images/pays/C2_Net_Banking.png'), sort: 11, company: 'happy' },//网上银行
		{ name: 'Korean Local Cards', type: 'CREDIT_CARD_KR', icon: require('@/assets/images/pays/Korean_Local_Cards.png'), sort: 12, company: 'enjoy' },
		// { name: 'South Korean Cards', type: 'KR_CARD', icon: require('@/assets/images/pays/South_korean_Card.png'), sort: 12, company: 'UGame' },
		{ name: 'mobile pay', type: 'MOBILE_PHONE_KR', icon: require('@/assets/images/pays/mobilepay.png'), sort: 13, company: 'enjoy', commission: '0.05' },
		{ name: 'Google Pay', type: 'GOOGLEPAY', icon: require('@/assets/images/pays/Google_Pay_Global.png'), sort: 14, company: 'happy' },
		// { name: 'Visa/MasterCard', type: 'AL_CARD', icon: require('@/assets/images/pays/Visa_Master_Card.jpg'), sort: 14, company: 'UGame' }
		{ name: 'T-money', type: 'T_MONEY', icon: require('@/assets/images/pays/T-money_KR.png'), sort: 15, company: 'enjoy', commission: '0.05' },
		{ name: 'HappyMoney', type: 'CULTURE_VOUCHER_KR', icon: require('@/assets/images/pays/happy_money.png'), sort: 16, company: 'enjoy', commission: '0.05' },
		{ name: 'Eggmoney', type: 'EGGMONEY', icon: require('@/assets/images/pays/Eggmoney_KR.png'), sort: 17, company: 'happy', commission: '0.15' },
	])
	const activePays = ref({})
	onMounted(() => {
		let querys = router.currentRoute.value.query
		payMoney.value = parseInt(querys.totalAmount) || 0
		goodName.value = querys.goodName || ''
		encode.value = querys.encode || ''
		handlePays(payTypes.value[0])
	})
	const handlePays = (row) => {
		const { name, type, company } = row
		activePays.value = Object.assign({},{ name, type, company })
		if(row.commission){
			commissionMoney.value = Math.ceil(payMoney.value * row.commission)
			activePays.value.commission = row.commission
		}else{
			commissionMoney.value = 0
			activePays.value.commission = 0
		}
		payRealMoney.value = payMoney.value + commissionMoney.value
		console.log(payRealMoney.value)
	}
	const handlePayment = () => {
		if(!activePays.value.name){
			proxy.$toast('Error！')
			return false
		}
		if(!encode.value){
			proxy.$toast('Error！')
			return false
		}
		orders.value = JSON.parse(proxy.$Base64.decode(encode.value))
		if(activePays.value.commission){
			orders.value.extraChargeRatio = activePays.value.commission
		}
		if(activePays.value.company == 'happy'){//happy公司
			payerMaxPay({
				paymentMethodType: activePays.value.type,
				terminalType: 'WEB',//设备终端，WEB，WAP，APP
				...orders.value
			}).then((res) => {
				console.log(res)
				if(res.data && res.data.redirectUrl){
					window.location.href = res.data.redirectUrl
				}else{
					proxy.$toast(res.msg)
				}
			})
		}else if(activePays.value.company == 'UGame'){
			ugamePay({ paymentMethodType: activePays.value.type, ...orders.value }).then((res) => {
				console.log(res)
				if(res.data && res.data.payUrl){
					window.location.href = res.data.payUrl
				}else{
					proxy.$toast(res.msg)
				}
			})
		}else{
			enjoyPay({ paymentMethodType: activePays.value.type, ...orders.value }).then((res) => {
				console.log(res)
				if(res.data && res.data.payData){
					window.location.href = res.data.payData
				}else{
					proxy.$toast(res.msg)
				}
			})
		}
	}
</script>

<style lang="less" scoped>
	.payments{
		width: 100%;height: calc(100vh - 5rem);max-width: 42rem;margin: 2.5rem auto;
		display: flex;align-items: center;justify-content: center;
		border-radius: 0.625rem;overflow: hidden;
		box-shadow: 0 0.25rem 0.9375rem rgba(0,0,0,.05);
	}
	.color1{
		color: #787878;
	}
	.moneyBox{
		width: 32%;height: 100%;position: relative;background: #fff;
		padding: 0.5rem 0.875rem 0;box-sizing: border-box;
		.topBox{
			width: 100%;border-bottom: 1px solid #EDEDED;
			display: flex;align-items: center;justify-content: space-between;
			padding: 0.625rem 0;font-size: 0.75rem;
		}
		.moneyInfos{
			text-align: center;padding: 1.875rem 0.625rem;
			p{
				line-height: 1.625rem;font-size: 0.75rem;
			}
			.price{
				line-height: 2.25rem;
				/deep/.el-statistic__content{
					font-size: 1.5rem;font-weight: 600;
				}
				&.s{
					/deep/.el-statistic__content{
						font-size: 1.375rem;
					}
				}
				&.ss{
					/deep/.el-statistic__content{
						font-size: 1.25rem;
					}
				}
			}
			.commission{
				color: #787878;display: inline-flex;justify-content: space-between;
				width: 100%;
				/deep/.el-statistic__content{
					font-size: 0.875rem;font-weight: 500;
				}
			}
			.commission + .commission{
				border-top: 1px solid #EDEDED;
			}
		}
		.footBox{
			width: 100%;position: absolute;left: 0;bottom: 0;
			padding: 0.3125rem 0.875rem;box-sizing: border-box;
			p{
				padding: 0.4375rem 0;font-size: 0.625rem;
				&:last-child{
					color: #C3C3C3;
				}
			}
			p + p{
				border-top: 1px solid #EDEDED;
			}
		}
	}
	.typesBox{
		width: 68%;height: 100%;
		background: #F5F5F4;
		padding: 5% 8.5% 0;box-sizing: border-box;
		.stitle{
			margin: 1rem 0 0.75rem;font-size: 0.75rem;
		}
		.typesList{
			height: calc(100% - 9rem);overflow-y: scroll;
			/* 整个滚动条 */
			::-webkit-scrollbar {
			    width: 0.1875rem; /* 设置滚动条的宽度 */
			}
			/* 滚动条轨道 */
			::-webkit-scrollbar-track {
			    background: #f1f1f1; /* 设置轨道的背景颜色 */
			}
			/* 滚动条的滑块 */
			::-webkit-scrollbar-thumb {
			    background: #888; /* 设置滑块的背景颜色 */
			}
			/* 滚动条的滑块hover效果 */
			::-webkit-scrollbar-thumb:hover {
			    background: #555; /* 设置滑块hover时的背景颜色 */
			}
			ul{
				li{
					display: flex;align-items: center;justify-content: space-between;
					border-radius: 0.625rem;background: #fff;padding: 0.375rem 0.875rem;box-sizing: border-box;
					border: 1px solid #fff;cursor: pointer;position: relative;
					.logo{
						width: 1.875rem;height: 1.875rem;border-radius: 100%;overflow: hidden;
						display: flex;align-items: center;justify-content: center;margin-right: 0.625rem;margin-left: 6.5%;
						img{
							width: 100%;
						}
					}
					.titles{
						flex: 1;font-size: 0.8125rem;color: #232323;font-weight: 500;
						display: flex;justify-content: space-between;align-items: center;
						padding-right: 0.625rem;
						span{
							color: red;font-weight: 400;font-size: 0.6875rem;
						}
					}
					.payRadio{
						width: 0.6875rem;height: 0.6875rem;border: 1px solid #9F9E9F;border-radius: 100%;
						box-sizing: border-box;
					}
					.sort{
						position: absolute;left: 2.5%;top: 50%;transform: translate(0, -50%);
						font-size: 16px;font-weight: 500;color: #9F9E9F;font-style: normal;
					}
					&.active{
						border: 1px solid #3A82FE;background: #EAF3FD;
						.payRadio{
							border: 0.1875rem solid #3A82FE;
						}
						.sort{
							color: #3A82FE;
						}
					}
				}
				li + li{
					margin-top: 0.625rem;
				}
			}
		}
		.btnBox{
			padding: 0.75rem 0;box-sizing: border-box;width: 100%;height: 100%;
			.payBtn{
				display: inline-block;width: 100%;height: 2.75rem;line-height: 2.75rem;text-align: center;
				background: #3A82FE;border-radius: 0.625rem;margin-bottom: 0.5rem;
				cursor: pointer;
				/deep/.el-statistic__content{
					font-size: 0.8125rem;color: #fff;
				}
			}
			p{
				text-align: center;color: #A3A3A3;font-size: 0.625rem;
				a{
					margin: 0 0.125rem;color: #3A82FE;cursor: pointer;
				}
			}
		}
	}
	@media screen and (orientation: landscape) and (max-height: 480px) {
		.payments{
			margin: 0.625rem auto;height: calc(100vh - 1.25rem);
		}
	}
	@media screen and (orientation: portrait) {
		.payments{
			width: 100%;height: 100vh;margin: 0 auto;
			flex-wrap: wrap;
		}
		.moneyBox{
			width: 100%;height: 36%;
		}
		.typesBox{
			width: 100%;height: 64%;
		}
	}
</style>